export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10252.e5ca5457.jpg";